import { useTranslation } from 'react-i18next';

import ProgressBar from '@appchoose/progress-bar';

interface CompletionBarProps {
  completedCount: number;
  totalCount: number;
  progressValue: number;
}

function CompletionBar({
  completedCount,
  totalCount,
  progressValue,
}: CompletionBarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex w-[220px] shrink-0 flex-col gap-1 px-4">
      <div className="flex items-center justify-center gap-1 whitespace-nowrap">
        <span className="text-sm font-medium">{completedCount}</span>
        <span className="text-xs font-normal text-muted-foreground">
          / {totalCount}{' '}
          {t('ui-v2.components.completion-bar.completed-variants')}
        </span>
      </div>
      <ProgressBar appearance="default" value={progressValue} />
    </div>
  );
}

export default CompletionBar;
